import { styled, CSSObject } from "styled-components";
import { vfxTheme } from "../common/VFX-UI/Theme/theme";


interface AppBarStyles {
    customPopover: CSSObject;
    customPopoverLink: CSSObject;
    headerItem: CSSObject;
    headerUser: CSSObject;
    headerUserText: CSSObject;

    menuItem: CSSObject;
    menuLink: CSSObject;
    badge: CSSObject;
    activeBadge: CSSObject;
    closeButton: CSSObject;
    flex: CSSObject;
    
    profileContainer: CSSObject;
    profileTopContainer: CSSObject;
    profileInfoContainer: CSSObject;
    profileText: CSSObject;
    profileName: CSSObject;
    profileInitials: CSSObject;
    profileInfo: CSSObject;
    profileLink: CSSObject;

    disableClickableMenu: CSSObject;
    hideClickableMenu: CSSObject;
    divAsLink: CSSObject;
    menuButton: CSSObject;
    menuBar: CSSObject;
}

const useAppBarStyles = (): AppBarStyles => {
    return {
        menuBar: {
            display: "flex",
            justifyContent: "space-between",
        },
        menuButton: {
            display: "flex",
            marginTop: vfxTheme.spaceUnits.sp02,
        },
        customPopover: {
            fontSize: "18px",
            borderRadius: 0,
            "&:.popover": {
                borderRadius: "0 !important",
            },
        },
        customPopoverLink: {
            textDecoration: "none",
            cursor: "pointer",
        },
        headerItem: {
            color: vfxTheme.palette.text.secondary,
            cursor: "pointer",
            verticalAlign: "middle",
        },
        headerUser: {
            color: vfxTheme.palette.white,
            backgroundColor: vfxTheme.palette.primary.main,
            borderColor: vfxTheme.palette.primary.main,
            borderRadius: "50%",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: "44px",
            height: "44px",
            padding: 0,
            lineHeight: 1,
            verticalAlign: "middle",
            fontSize:"1.5em"
        },

        headerUserText: {
            color: vfxTheme.palette.white,
            fontSize: "18px"
        },
               
        menuItem: {
            backgroundColor: vfxTheme.palette.background.default,
            fontSize: 16,
            fontWeight: 600,
            color: vfxTheme.palette.blues.b800,
            marginRight: vfxTheme.spaceUnits.sp05,
            fontFamily: vfxTheme.typography.fontFamily,
            fontStyle: "normal",
            lineHeight: "20px",
        },
        menuLink: {
            color: vfxTheme.palette.blueGreys.bg800,
            fontWeight: 600,
            textDecoration: "none",
        },
        badge: {
            alignItems: "center",
            backgroundColor: vfxTheme.palette.blues.b50,
            color: vfxTheme.palette.blues.b200,
            borderRadius: "50%",
            height: "44px",
            justifyContent: "center",
            width: "44px",
        },
        activeBadge: {
            backgroundColor: vfxTheme.palette.oranges.o300,
            color: vfxTheme.palette.background.default,
        },
        closeButton: {
            backgroundColor: vfxTheme.palette.background.default,
            color: vfxTheme.palette.blues.b500,
        },
        flex: {
            alignSelf: "center",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
        },
        
       
        profileContainer: {
            //width: "320px",
            minWidth: "350px",
            //maxWidth:"550px"
        },
        profileTopContainer: {
            display: "flex",
            justifyContent: "space-between",
        },
        profileInfoContainer: {
            marginTop:"auto",
        },
        profileText: {
            cursor: "pointer",
            color: vfxTheme.palette.text.secondary,
            fontSize: "14px",
            letterSpacing: "0.01071em",
            padding: 0,
        },
        profileName: {
            fontFamily: vfxTheme.typography.fontFamily,
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "11.79px",
        },
        profileInitials: {
            color: vfxTheme.palette.white,
            backgroundColor: vfxTheme.palette.primary.main,
            borderColor: vfxTheme.palette.primary.main,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "68px",
            height: "68px",
            padding: 0,
            lineHeight: 1,
            fontSize:"2em",
        },
        profileInfo: {
            fontFamily: vfxTheme.typography.fontFamily,
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "14.63px",
        },
        profileLink: {
            color: vfxTheme.palette.blues.b500,
            cursor: "pointer",
            fontSize: "14px",
            padding: 0,
            textDecoration: "underline",
        },

        disableClickableMenu: {
            pointerEvents: "none",
            color: vfxTheme.palette.blueGreys.bg50,
        },
        hideClickableMenu: {
            display: "none",
        },
        divAsLink: {
            cursor: "pointer",
        },
    };
};

export const ListItem = styled.li`
  min-width: 150px;
  font-size: 16px !important;
  font-weight: ${vfxTheme.fontWeights.regular};
  background-color: white;
  list-style: none;
  padding: ${vfxTheme.spaceUnits.sp01 * 2}px;
  &:hover {
    background-color: ${vfxTheme.palette.blueGreys.bg50};
    cursor: pointer;
  }
`;

export const AnchorLink = styled.a`
  font-weight: ${vfxTheme.fontWeights.regular};
  text-decoration: none;
  color: black;
`;

export default useAppBarStyles;
